import { OpenIdService } from '../service/open-id.service';
import { OpenIdProfileMixin } from './open-id-profile.mixin';
import { PaginatorMixin } from './paginator.mixin';

class GenericBase {}

class OpenIdBase {
    constructor(protected openIdService: OpenIdService) {}
}

export const OpenIdProfileBase = OpenIdProfileMixin(OpenIdBase);
export const PaginatorBase = PaginatorMixin(GenericBase);

export const OpenIdProfilePaginatorBase = PaginatorMixin(
    OpenIdProfileMixin(OpenIdBase)
);
